import axios from "../config/axios-mcp";

const cleanParams = (params) => {
    const result = {};
    for (const [key, value] of Object.entries(params || {})) {
        if (value !== undefined && value !== null && value !== "") result[key] = value;
    }
    return result;
};

// flow_uid: legacy Firestore flow id. projectId/subProjectId: the registry project's own ids
// (Project API) - at least one of the three is required by the backend.
const scopeParams = ({flowUid, projectId, subProjectId} = {}) =>
    cleanParams({flow_uid: flowUid, project_id: projectId, subproject_id: subProjectId});

export const MCPServersRepository = {
    getAll: (scope) => {
        return axios.get(`api/servers/by-project`, {params: scopeParams(scope)});
    },
    reloadServer: (id) => {
        return axios.post(`api/servers/${id}/reload`);
    },
    delete: (id) => {
        return axios.delete(`api/servers/${id}`)
    },
    create: (data) => {
        return axios.post('api/servers', data)
    },
    edit: (id, data) => {
        return axios.patch(`api/servers/${id}`, data)
    },
    testConnection:(data)=>{
        return axios.post(`api/servers/test-connection`,data);
    },
    editServerToken:(id,data)=>{
        return axios.patch(`api/servers/${id}/token`,data);
    },
    getTools:(data)=>{
        return axios.post(`api/mcp/tools`,data);
    },
    callTool:(data)=>{
        return axios.post(`api/mcp/call`,data);
    },
    getPrompts:(data)=>{
        return axios.post(`api/mcp/prompts`,data);
    },
    getToolDetails:(data)=>{
        return axios.post(`api/mcp/get-tool-details`,data);
    },
    getAllServersWithDetails:(scope)=>{
        return axios.get(`api/servers/by-project/servers-details`, {params: scopeParams(scope)});
    },
    getServerWithDetails:(server_id)=>{
        return axios.get(`api/servers/${server_id}/server-details`);
    },
    deleteInactiveTool:(tool_id)=>{
        return axios.delete(`api/mcp/${tool_id}`);
    }
}